import React from 'react';
import { IGamePageProps } from './GamePage.types';
import GameContainer from '../../containers/GameContainer/GameContainer';

const GamePage: React.FC<IGamePageProps> = ({ match }: IGamePageProps) => {
  return <GameContainer routeParams={match.params} />;
};

export default GamePage;
